<div class="container-fluid">
  <app-custom-table-title [icon]="kind.icon" [title]="kind.title" [subTitle]="kind.subTitle"></app-custom-table-title>
  <div class="mt-4 mb-4 cf-table-card">

    <ng-template #assetSummary>
      <div class="total-card">
        <p class="label">{{ hasSelection ? 'Seleccionadas' : 'Inversiones' }} <strong>{{ totals.count }}</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Total <strong>{{ totals.total | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Pagado <strong>{{ totals.paid | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Pendiente <strong>{{ totals.pending | number:'1.2-2' }} €</strong></p>
      </div>
    </ng-template>

    <ng-template #quickFilter>
      <div class="quick-filter">
        <app-search-filter [value]="quickSearch" [placeholder]="kind.searchPlaceholder" (searchChange)="onSearchChange($event)"></app-search-filter>
      </div>
    </ng-template>

    <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>

    <ng-template #expandDetail let-row>
      <app-investment-asset-detail
        [row]="row"
        [type]="type"
        (changed)="reload()"
        (edit)="edit(row)">
      </app-investment-asset-detail>
    </ng-template>
  </div>
</div>
